import React from "react";
import styled from "styled-components";

export default styled.p`
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  color: ${(props) => props.theme.franceBlue};
`;
